




























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import RateCardDto from '@/models/RateCards/RateCardDto';
import UpdateRateCardRequest from '@/models/RateCards/UpdateRateCardRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'CompanyRateCardEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new RateCardDto

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(CompanyDetailsModule.currentRateCard));
    }
  }

  get loading() {
    return CompanyDetailsModule.loadingDialog;
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateRateCardRequest()
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    request.driverUnitExpenseChargeRate = this.entity.driverUnitExpenseChargeRate;
    await CompanyDetailsModule.editRateCard(request)
    this.dialog = false;
  }
}
